<template>
  <transition name="el-fade-in">
    <div class="all" v-show="show">
      <div class="title">{{ name || "Library" }}</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/library-list' }">Target Areas list</el-breadcrumb-item>
        <el-breadcrumb-item>
          {{
          name || "select library"
          }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <page-editer
        ref="editer-library"
        :modelData.sync="data"
        :render="renderData"
        :handlerSave="Save"
        :handlerDelete="Delete"
        :hideDeleteBtn="true"
        :handleLoad="Loaded"
      >
        <template slot="ShowTitle">
          {{ title }}
        </template>
      </page-editer>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      name: "Target Areas select",
      show: false,
      title: "",
      renderData: [
        {
          key:'Target Area',
          type:'slot',
          slotName:'ShowTitle'
        },
        // {
        //   key: "Workout list",
        //   type: "transfer",
        //   modelName: "idList",
        //   transferBase: [],
        //   repeat: true,
        //   isNoSort: true
        // },
        {
          key: "Workout list",
          type: "transfer2",
          modelName: "idList",
          transferBase: [],
          repeat: false,
          sortable: false,
          BasekeyID: "id",
          // DatakeyID: "workoutId",
          TreeTableState: false,
          noPagin: true,
          showRender: [
            {
              name: "Name",
              modelName: "title"
            },
            {
              name: "Focus areas",
              modelName: "focusArea"
            },
            {
              name: "Target Areas Name",
              modelName: "targetAreasName"
            }
          ],
          searchRander: [
            {
              placeholder: "Name",
              modelName: "title",
              type: "input"
            },
            {
              placeholder: "Focus areas",
              modelName: "focusArea",
              noNone:true,
              type: "selects",
              options: this.$deepCopy(
                this.$store.state.optionBase.focusArea
              ).map(i => {
                i.value = i.label;
                return i;
              })
            }
          ],
          dataRander: [
            {
              name: "Name",
              modelName: "title"
            }
          ],
          BaseLocalSearch: true,
          getBase: config => {
            config = config || {};
            return new Promise(resolve => {
              config = {
                pageSize: 100,
                pageNum: 1,
                hasTargetAreasName: 1,
                ...config
              };
              this.$request(
                "/manage/workout/list",
                config,
                res => {
                  if (res.data.code === 200) {
                    res.data.list = res.data.data;
                    resolve(res.data);
                  }
                },
                "post",
                true,
                true
              );
            });
          },
          // isSelectCheck: row => {
          //   let state = true;
          //   if (row.targetAreasName) {
          //     state = false;
          //   }
          //   return state;
          // }
        }
      ],
      data: {
        name: "",
        description: ""
      }
    };
  },
  methods: {
    Save() {
      let uploadData = this.$deepCopy(this.data);
      this.renderData.some(item => {
        // 多选数组转字符串数组
        if (item.type === "selects" && this.data[item.modelName]) {
          uploadData[item.modelName] = this.data[item.modelName].toString();
        }
      });
      this.$request(
        `/manage/library/saveWorkouts/${this.$route.query.id}`,
        {
          idList: uploadData.idList.map(item => item.id)
        },
        res => {
          if (res.data.code === 200) {
            this.$message({
              message: "save success",
              type: "success"
            });
            this.$router.push("/library-list");
          }
        }
      );
    },
    Delete() {
      console.log(this.$route.query.id);
    },
    getOrder() {
      // let Array = [],
      //     Array2 = [];
      // let lableDoms = this.$refs.transfer.$el
      //     .querySelectorAll(".el-checkbox-group")[1]
      //     .querySelectorAll(".el-checkbox__label");
      // for (let i = 0; i < lableDoms.length; i++) {
      //     Array.push(lableDoms[i].querySelector("span").innerText);
      // }
      // Array.some((item2) => {
      //     this.transferBase.some((item) => {
      //         if (item2 === item.exerciseName) {
      //             Array2.push(item);
      //         }
      //     });
      // });
      // this.trueOrder = Array2;
      1;
    },
    Loaded() {
      console.log("load");
      this.show = true;
      if (this.$route.query.id && this.$route.query.id != "add") {
        this.title = this.$route.query.name;
        this.$request(
          `/manage/library/workouts/${this.$route.query.id}`,
          {},
          res => {
            let data = res.data.data;
            this.renderData.some(item => {
              if (item.type === "selects" && data[item.modelName]) {
                data[item.modelName] = data[item.modelName].split(",");
              }
            });
            this.data.idList = data;
          },
          "post",
          true
        );
      }
      // 获取exercise的列表 导入进 transfer
      // this.$request("/manage/workout/list", {}, res => {
      //   if (res.data.code === 200) {
      //     this.renderData.some(item => {
      //       if (item.modelName === "idList") {
      //         item.transferBase = res.data.data;
      //       }
      //     });
      //   }
      // });
    }
  },
  created() {
    // this.show = true;
    // if (this.$route.query.id && this.$route.query.id != "add") {
    //     this.$request(
    //         `/manage/library/workouts/${this.$route.query.id}`,
    //         {},
    //         (res) => {
    //             let data = res.data.data;
    //             this.renderData.some((item) => {
    //                 if (item.type === "selects" && data[item.modelName]) {
    //                     data[item.modelName] = data[item.modelName].split(",");
    //                 }
    //             });
    //             this.$set(data,'idList',data)
    //             console.log(this.data)
    //         },
    //         "post",
    //         true
    //     );
    // }
    // // 获取exercise的列表 导入进 transfer
    // this.$request("/manage/workout/list", {}, (res) => {
    //     if (res.data.code === 200) {
    //         this.renderData.some((item) => {
    //             if (item.modelName === "idList") {
    //                 item.transferBase = res.data.data;
    //             }
    //         });
    //     }
    // });
  }
};
</script>

<style scoped>
.all {
  box-sizing: border-box;
  padding: 0 40px;
  text-align: left;
  font-size: 13px;
  margin-top: 30px;
}
.all >>> .ShowTitle{
  line-height: 27px;
}
.title {
  font-size: 24px;
  line-height: 50px;
}
.name{
  display: flex;
  align-items: center;
}
.el-breadcrumb {
  height: 20px;
  line-height: 20px;
  margin-top: 30px;
}
/* .kuai-con .el-input >>> input
{
    font-size: 13px;
    height: 27px;
} */
</style>